import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IMissionVirtualState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const missionVirtualModule: Module<IMissionVirtualState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default missionVirtualModule